import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSZ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M47.52 35.87A24.9 24.9 0 0 0 50 25a24.9 24.9 0 0 0-2.48-10.87L25 13.045 2.48 14.13A24.902 24.902 0 0 0 0 25a24.9 24.9 0 0 0 2.48 10.87L25 36.957l22.52-1.087Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M25 0C15.087 0 6.523 5.768 2.48 14.13h45.038C43.475 5.768 34.911 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50C15.087 50 6.523 44.23 2.48 35.868h45.038C43.475 44.231 34.911 49.999 25 49.999Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M48.82 17.392H1.18A24.982 24.982 0 0 0 0 25c0 2.654.415 5.21 1.18 7.609h47.64C49.584 30.209 50 27.653 50 25c0-2.653-.415-5.21-1.18-7.608Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M8.696 23.913h32.608v2.174H8.696v-2.174ZM13.043 19.565h23.913v2.174H13.042v-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M37.112 25S31.522 31.523 25 31.523c-6.521 0-6.521-6.521-6.521-6.521s0-6.522 6.521-6.522c6.522 0 12.112 6.521 12.112 6.521Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M25 31.522c-6.52 0-12.11-6.521-12.11-6.521s5.59-6.522 12.11-6.522"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M20.653 22.827h2.174v4.347h-2.174v-4.347Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M27.174 22.827h2.174v4.347h-2.174v-4.347Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M8.695 27.174a2.174 2.174 0 1 0 0-4.347 2.174 2.174 0 0 0 0 4.347ZM41.304 27.174a2.174 2.174 0 1 0 0-4.347 2.174 2.174 0 0 0 0 4.347Z"
}));
FlagSZ.displayName = 'FlagSZ';
export default withFlagWrapper(FlagSZ);
//# sourceMappingURL=index.js.map